import { toaster } from 'evergreen-ui';
import Request from '../../../util/Api';
import ModuleConfig from '../Config';

const actions = ModuleConfig.Actions;
const endpoints = ModuleConfig.Endpoints;
const CRUDActions = ModuleConfig.CRUDActions;
const CalendarEvent = ModuleConfig.Structures.CalendarEvent;

export function getEvents(opts = {}) {
    const { startDate, endDate, location, ...otherOpts } = opts;

    return CRUDActions.getAll(
        actions.getAll,
        {
            start: 0,
            limit: 1000,
            ...otherOpts,
            endpoint: endpoints.events,
            mapStructure: CalendarEvent,
            errorNotification: "Events could not be loaded"
        },
        { startDate, endDate, location } // Pass as third parameter for extraFind
    );
}

export function getEvent(id) {
    return CRUDActions.getOne(actions.getOne, {
        id,
        endpoint: endpoints.event,
        mapStructure: CalendarEvent,
        errorNotification: "Event could not be loaded"
    });
}

export function createEvent(values) {
    return CRUDActions.create(actions.create, {
        values,
        endpoint: endpoints.events,
        mapStructure: CalendarEvent,
        successNotification: "Event created successfully",
        errorNotification: "Event could not be created"
    });
}

export function updateEvent(id, values) {
    return CRUDActions.update(actions.edit, {
        id,
        values,
        endpoint: endpoints.event,
        mapStructure: CalendarEvent,
        successNotification: "Event updated successfully",
        errorNotification: "Event could not be updated"
    });
}

export function deleteEvent(id) {
    return async (dispatch) => {
        dispatch({ type: actions.delete.request.id, options: { id } });

        try {
            await Request.delete(endpoints.event, { id });

            dispatch({ type: actions.delete.success.id, options: { id } });
            toaster.success("Event deleted successfully");
        } catch (error) {
            dispatch({ type: actions.delete.failure.id, options: { error } });
            toaster.danger("Event could not be deleted");
            throw error;
        }
    };
}

export function updateEventPosition(id, position) {
    return async (dispatch) => {
        try {
            await Request.patch(`${endpoints.event.replace('[id]', id)}/position`, {}, {}, { position });
            toaster.success("Event position updated");
        } catch (error) {
            toaster.danger("Event position could not be updated");
            throw error;
        }
    };
}

export function duplicateEvent(event, { silent = false } = {}) {
    return async (dispatch) => {
        const { id, createdAt, updatedAt, revision, slug, ...eventData } = event;

        try {
            const result = await Request.post(endpoints.events, {}, {}, eventData);

            // silent: caller batches several duplications and shows one summary toast
            if (!silent) toaster.success("Event duplicated successfully");

            // Return the new event ID so caller can navigate to it
            return result.data;
        } catch (error) {
            toaster.danger("Event could not be duplicated");
            throw error;
        }
    };
}

export function publishMonth({ startDate, endDate, location }) {
    return async () => {
        const response = await Request.post('/events/publish-month', {}, {}, { startDate, endDate, location });
        return response.data;
    };
}

export function finalizeEvent(id) {
    return async (dispatch) => {
        try {
            const response = await Request.post(`/events/${id}/finalize`, {}, {}, {});

            toaster.success("Event finalized successfully");
            return response;
        } catch (error) {
            toaster.danger(`Failed to finalize event: ${error.message || 'Unknown error'}`);
            throw error;
        }
    };
}
